import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { getOrCreateAnonymousUserKey } from '../utils/ld-anonymous-id';

export const createLaunchDarklyProvider = async (
  clientSideID: string,
): Promise<({ children }: { children: React.ReactNode }) => React.JSX.Element> => {
  const originUrl: string = window.location.href;
  const userKey: string = getOrCreateAnonymousUserKey();

  return await asyncWithLDProvider({
    clientSideID,
    context: {
      kind: 'user',
      key: userKey,
      anonymous: true,
      originUrl,
    },
    options: {
      bootstrap: 'localStorage',
    },
    timeout: 5,
  });
};
